(() => {
  const BUREAU = window.matchMedia('(min-width: 750px)');

  const equiper = (enveloppe) => {
    if (enveloppe.__hfSelect) return;
    const champ = enveloppe.querySelector('select');
    if (!champ) return;
    enveloppe.__hfSelect = true;

    const liste = document.createElement('ul');
    liste.className = 'hf-select__list';
    liste.setAttribute('aria-hidden', 'true');
    enveloppe.appendChild(liste);

    let actif = -1;

    const construire = () => {
      liste.textContent = '';
      Array.from(champ.options).forEach((option, i) => {
        const item = document.createElement('li');
        item.className = 'hf-select__option';
        item.textContent = option.textContent;
        item.dataset.index = String(i);
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(i === champ.selectedIndex));
        if (option.disabled) item.setAttribute('aria-disabled', 'true');
        liste.appendChild(item);
      });
    };

    const surligner = (i) => {
      actif = i;
      liste.querySelectorAll('.hf-select__option').forEach((el, k) => {
        el.dataset.active = String(k === i);
      });
      const el = liste.children[i];
      if (el) el.scrollIntoView({ block: 'nearest' });
    };

    const ouvrir = () => {
      if (!BUREAU.matches) return;
      construire();
      enveloppe.dataset.open = 'true';
      surligner(champ.selectedIndex);
    };

    const fermer = () => {
      enveloppe.dataset.open = 'false';
      actif = -1;
    };

    const choisir = (i) => {
      const option = champ.options[i];
      if (!option || option.disabled) return;
      champ.selectedIndex = i;
      champ.dispatchEvent(new Event('change', { bubbles: true }));
      fermer();
    };

    champ.addEventListener('mousedown', (e) => {
      if (!BUREAU.matches) return;
      e.preventDefault();
      if (enveloppe.dataset.open === 'true') fermer();
      else { champ.focus(); ouvrir(); }
    });

    champ.addEventListener('keydown', (e) => {
      if (!BUREAU.matches) return;
      const ouvert = enveloppe.dataset.open === 'true';
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) {
        e.preventDefault();
        if (!ouvert) return ouvrir();
        if (e.key === 'Enter' || e.key === ' ') return choisir(actif);
        let i = actif;
        do {
          i += e.key === 'ArrowDown' ? 1 : -1;
        } while (champ.options[i] && champ.options[i].disabled);
        if (champ.options[i]) surligner(i);
      } else if (e.key === 'Escape' && ouvert) {
        e.preventDefault();
        fermer();
      } else if (e.key === 'Tab') {
        fermer();
      }
    });

    liste.addEventListener('mousedown', (e) => e.preventDefault()); // garde le focus
    liste.addEventListener('click', (e) => {
      const item = e.target.closest('.hf-select__option');
      if (item) choisir(Number(item.dataset.index));
    });

    document.addEventListener('click', (e) => {
      if (!enveloppe.contains(e.target)) fermer();
    });
    champ.addEventListener('blur', fermer);
    champ.addEventListener('change', fermer);
  };

  const balayer = (racine) => {
    (racine || document).querySelectorAll('[data-hf-select]').forEach((el) => {
      el.classList.add('hf-select--enhanced');
      equiper(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => balayer());
  } else {
    balayer();
  }
  document.addEventListener('shopify:section:load', (e) => balayer(e.target));
})();
